/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */
import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';

export interface AdminBreadcrumbItemType {
  label: string;
  url?: string;
  isDisabled?: boolean;
}

export default function AdminBreadcrumbItem({ label, url, isDisabled }: AdminBreadcrumbItemType) {
  const history = useHistory();

  if (!url || isDisabled) {
    return <span>{label}</span>;
  }

  const handleClick = () => history.push(url);

  return (
    <Button className='d-inline-flex p-0' color='link' onClick={handleClick}>
      {label}
    </Button>
  );
}
